
import Vue from 'vue'
import { route } from '@/middleware/middleware'

export default Vue.extend({
  middleware: [route],
  head(): any {
    const title = this.App.state.current?.title
    const titleTemplate = title ? '%s - ' + process.env.APPLICATION_NAME : null

    return {
      title,
      titleTemplate
    }
  },
  created() {
    this.App.state.layout = 'auth'
  }
})
